import { ITimelineItem } from '@clients/timelineClient';
import TimelineItemFactory from '@components/accountTimeline/accountTimelineBlock/TimelineItemFactory';

interface TransactionDetailsHeaderProps {
    timelineItem: ITimelineItem;
    isLoading: boolean;
}

const TimelineDetailsHeader = ({
    timelineItem,
    isLoading,
}: TransactionDetailsHeaderProps) => {
    if (isLoading) {
        const dummy: ITimelineItem = {
            type: 'SKELETON',
            account_id: 0,
            category: '',
            tenant_account_timestamp: '',
            timestamp: '',
            data: { item: {} },
            correlation_id: '',
        };
        return <TimelineItemFactory timelineItem={dummy} />;
    }

    return <TimelineItemFactory timelineItem={timelineItem} />;
};

export default TimelineDetailsHeader;
